import React, { Component } from 'react';
import Tools from '../../tools.js';
import API from '../../api';
import ListView from '../utils/ListView';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
// import { Col, Row } from 'react-bootstrap';
import Enums from '../../enums';
import Loading from '../Loading';
import { Button } from 'react-bootstrap';
import { FaCopy } from 'react-icons/fa';

class ProjectsCustApp extends React.Component {
    E_TYPE = {
        ALL: 0,
        SINGLE: 1
    };

    constructor() {
        super();
        Tools.init();
        API.init(this);
        let isAdmin = API.getIsAdmin();
        // console.log("isAdmin", isAdmin);

        this.state = {
            ty: this.E_TYPE.ALL,
            list: [],
            hideIndexList: [
                false,
                false,
                false,
                false,
                false,
                false,
                false,
                isAdmin == 2 ? false : true,
                true,
                true,
            ],
            page_max: 20,
            filter: null,
            list_index_min: 0,
            list_index_max: 20,
            page_index: 0,
            fields: [
                "主題",
                "開始時間",
                "結束時間",
                "狀態",
                // "預定填答人數",
                "調查樣本",
                "完成人數",
                "差額",
                "花費點數",
                "",
                ""
            ],
            isLoading: false,
            isHeaderDownloadable: isAdmin == 1 ? true : false,
            isRowDownloadable: true,
            isAnserRecordDownloadable: isAdmin == 1 ? true : false,
        };
        this.getData = this.getData.bind(this);
        this.onListViewClicked = this.onListViewClicked.bind(this);
        this.getDisplayDiffPeople = this.getDisplayDiffPeople.bind(this);
        this.onClickDownloadQuestion = this.onClickDownloadQuestion.bind(this);
        this.onClickDownloadAnswerRecord = this.onClickDownloadAnswerRecord.bind(this);
        this.renderDownload = this.renderDownload.bind(this);
        this.renderRecordDownload = this.renderRecordDownload.bind(this);
        this.onClickCopyProject = this.onClickCopyProject.bind(this);
        this.renderCopy = this.renderCopy.bind(this);
        //using set timeout to make setState working
        setTimeout(() => this.getData(), 0);
    }

    getData() {
        this.setState({ isLoading: true });
        var tmpData = {
            ty: this.state.ty
        };
        API.GetProjects(tmpData, this.onDataUpdated.bind(this));
    }

    getDisplayDiffPeople(tmpObj) {
        if (tmpObj.max_people == 0) return 0;
        return tmpObj.max_people - tmpObj.complete_people;
    }

    onListViewClicked(index) {
        console.log(index, this.props.history);
        // alert("沒有datail介面ppt (其實連這頁list也沒資料,但有api就順手做了)");
        this.props.history.push("/proj/edit/" + index);
        // window.open(this.props.history.createHref({
        //     pathname: "/proj/edit/" + index
        // }));

        // window.open(this.props.history.createHref("/proj/add?pid=" + index));
    }

    onDataUpdated(data) {
        this.setState({ isLoading: false });
        // console.log(this);
        if (data && data.data) {
            // console.log(data);
            const tmp = [];
            for (let index in data.data) {
                const tmpObj = data.data[index];
                tmp.push({
                    key: tmpObj.pid,
                    data: [
                        tmpObj.name,
                        Tools.getFormatDate(tmpObj.start_at),
                        Tools.getFormatDate(tmpObj.end_at),
                        tmpObj.status,
                        // tmpObj.max_people,
                        tmpObj.max_people,
                        tmpObj.complete_people,
                        this.getDisplayDiffPeople(tmpObj),
                        tmpObj.point,
                        tmpObj.updated_at,
                        tmpObj.pid
                    ]
                });
            }
            this.setState({
                list: tmp,
                sort_type: [
                    Enums.ESORT.STR,
                    Enums.ESORT.DATETIME,
                    Enums.ESORT.DATETIME,
                    Enums.ESORT.STR,
                    Enums.ESORT.NUM,
                    Enums.ESORT.NUM,
                    Enums.ESORT.NUM,
                    Enums.ESORT.NUM,
                    Enums.ESORT.NUM,
                    Enums.ESORT.STR,
                ]
            })
        }
    }

    onClickDownloadQuestion(id, e) {
        e.stopPropagation();
        e.preventDefault();
        console.log("onClickDownloadQuestion", id);

        API.GetAnswerRecordContentCSV({
            pi: id
        }).then(response => {
            console.log(response);

            if (response && response.response && response.response.status == 200) {
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(response.responseData);
                link.download = "GetAnswerRecordContentCSV.csv";
                link.click();
            } else {
                alert("資料下載錯誤");
            }
        }) // JSON from `response.json()` call
            .catch(error => console.error(error));
        // window.open(this.props.history.createHref("/proj/add?pid=" + index));
    }

    onClickDownloadAnswerRecord(id, e) {
        e.stopPropagation();
        e.preventDefault();
        console.log("onClickDownloadAnswerRecord", id);

        API.GetAnswerRecordCSV({
            pi: id
        }).then(response => {
            console.log(response);

            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(response.responseData);
            link.download = "GetAnswerRecordCSV.csv";
            link.click();
        }) // JSON from `response.json()` call
            .catch(error => console.error(error));
    }

    renderDownload(id, item) {
        return (
            <>
                <Button variant="link" onClick={(e) => { this.onClickDownloadQuestion(id, e) }}>問卷資料</Button>
                {(null != item && 1 == item.is_published) ? (<Button variant="link" onClick={(e) => { this.onClickDownloadQuestion(id, e) }}>填答資料</Button>) : null}
            </>
        );
    }

    renderRecordDownload(id, item) {
        return (
            <>
                <Button variant="link" onClick={(e) => { this.onClickDownloadAnswerRecord(id, e) }}>問卷代碼資料</Button>
                {(null != item && 1 == item.is_published) ? (<Button variant="link" onClick={(e) => { this.onClickDownloadAnswerRecord(id, e) }}>填答資料</Button>) : null}
            </>
        );
    }

    onClickCopyProject(id, e) {
        console.log("onClickCopyProject", 1);
        if (!window.confirm("確定要複製此專案嗎？")) {
            console.log("onClickCopyProject", 2);
            return;
        }
        console.log("onClickCopyProject", 3);
        this.setState({ isLoading: true });
        API.ProjectDuplicate({ pi: id })
            .then(({ response, responseData, newPi }) => {
                this.setState({ isLoading: false });
                if (responseData && responseData.code === "22000") {
                    // alert("專案複製成功");
                    this.getData();
                } else {
                    alert("專案複製失敗");
                }
            })
            .catch(error => {
                this.setState({ isLoading: false });
                console.error(error);
                alert("專案複製失敗");
            });
    }

    renderCopy(id) {
        return (
            <Button variant="link" size="sm" title="複製專案"
                onClick={(e) => { e.stopPropagation(); e.preventDefault(); this.onClickCopyProject(id, e); }}>
                <FaCopy />
            </Button>
        );
    }

    render() {
        const { list, sort_type, fields, hideIndexList, isLoading,
            isHeaderDownloadable, isRowDownloadable, isAnserRecordDownloadable } = this.state,
            totalEntries = list.length,
            { onListViewClicked, renderDownload, renderRecordDownload, renderCopy } = this;
        return (
            <div className="Row">
                <ListView list={list}
                    sort_type={sort_type}
                    fields={fields}
                    title={"專案列表"}
                    onRowClicked={onListViewClicked}
                    sort_index={8}
                    ascending={false}
                    fileName={"GetProjectsSummaryCSV"}
                    hideIndexList={hideIndexList}
                    renderDownload={renderDownload}
                    renderRecordDownload={renderRecordDownload}
                    renderCopy={renderCopy}
                    isHeaderDownloadable={isHeaderDownloadable}
                    isRowDownloadable={isRowDownloadable}
                    isAnserRecordDownloadable={isAnserRecordDownloadable}
                />
                <Loading isLoading={isLoading} />
            </div>
        );
    }
}

// ReactDOM.render(
//     React.createElement(ProjectsCustApp),
//     document.getElementById('root')
// );

const mapStateToProps = (state) => ({
    id: state.authReducer.id
})

const mapDispatchToProps = {

}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ProjectsCustApp))